<template>
  <div class="rating-scale">
    <div class="rating-bar">
      <div class="rating-progress" :style="progressCss"></div>
    </div>
    <div class="ratings">
      <div
        class="rating"
        v-for="(label, no) in question.question"
        :key="no"
        @click="updateAnswer(no)"
      >
        <div class="rating-number" :class="{ active: no === answer }">
          <span>{{ no }}</span>
        </div>
        <span class="rating-label" v-html="bb(label)"></span>
      </div>
    </div>
  </div>
</template>

<script>
import bbCodeParser from 'js-bbcode-parser';

export default {
  name: 'RatingScale',
  props: {
    question: {
      type: Object,
      required: true,
    },
    answer: {
      required: false,
    },
  },

  // data() {
  //   return {
  //     internalAnswer: this.answer,
  //   };
  // },

  methods: {
    bb(str) {
      return bbCodeParser.parse(str);
    },

    updateAnswer(no) {
      // this.internalAnswer = no;
      this.$emit('input', no);
    },
  },
  computed: {
    progressCss() {
      // const a = this.internalAnswer;
      const a = this.answer;
      const len = Object.keys(this.question.question).length - 1;
      const c = len + 1;
      const wPerc = a > 0 ? ((a - 1) / len) * 100 : 0;
      const wPx = wPerc === 0 ? 0 : c * 10 - (a || 0) * 10;
      const width = `calc(${wPerc}% + ${wPx}px)`;

      return { width };
    },
  },
};
</script>

<style lang="scss" scoped>
.rating-scale {
  position: relative;
  width: 80%;
  margin: 0 auto;
  top: 50%;
  transform: translateY(-50%);

  .rating-bar {
    position: absolute;
    width: 100%;
    height: 60px;
    background-color: #eaf3f4;
    border-radius: 10000px;
    z-index: -1;

    .rating-progress {
      width: 0;
      height: 100%;
      background: linear-gradient(to right, rgba(#a0dced, 0.43), #a0dced);
      border-radius: 10000px;
    }
  }

  .ratings {
    display: flex;
    justify-content: space-between;

    .rating {
      position: relative;
      cursor: pointer;

      .rating-number {
        position: relative;
        width: 60px;
        height: 60px;
        background-color: #d7f1f8;
        border-radius: 100%;

        span {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: #3486a3;
          font-weight: bold;
        }

        &.active {
          background-color: #3486a3;

          span {
            color: white;
          }
        }
      }

      .rating-label {
        position: absolute;
        width: 140%;
        left: -20%;
        top: calc(100% + 10px);
        text-align: center;
      }
    }
  }
}
</style>
